export const StatBar = ({ label, value, max = 10, delay = 0, compact = false }) => (
  <div className="flex items-center gap-3" data-testid={`stat-${label.toLowerCase().replace(/\s+/g, "-")}`}>
    <span className={`eyebrow ${compact ? "w-20" : "w-32"} shrink-0 leading-tight !tracking-[0.08em] text-rox-off/80`}>{label}</span>
    <div className="h-[5px] flex-1 overflow-hidden rounded-sm bg-rox-gray">
      <div
        className="h-full bg-rox-orange animate-fill-bar"
        style={{ width: `${(value / max) * 100}%`, animationDelay: `${delay}ms` }}
      />
    </div>
    <span className="w-10 shrink-0 text-right font-display text-sm tracking-wide">
      {value}/{max}
    </span>
  </div>
);
